/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Conversation,
  ConversationRequest,
  InboxConversationsListParams,
  InboxConversationsMessagesListParams,
  InboxSummary,
  Message,
  PaginatedConversationList,
  PaginatedMessageList,
  PatchedConversationRequest,
  SendRequest,
  SimulateRequest,
  VoiceRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type inboxConversationsListResponse200 = {
  data: PaginatedConversationList
  status: 200
}
    
export type inboxConversationsListResponseSuccess = (inboxConversationsListResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsListResponse = (inboxConversationsListResponseSuccess)

export const getInboxConversationsListUrl = (params?: InboxConversationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/inbox/conversations/?${stringifiedParams}` : `/api/v1/inbox/conversations/`
}

export const inboxConversationsList = async (params?: InboxConversationsListParams, options?: RequestInit): Promise<inboxConversationsListResponse> => {
  
  return apiFetch<inboxConversationsListResponse>(getInboxConversationsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getInboxConversationsListQueryKey = (params?: InboxConversationsListParams,) => {
    return [
    `/api/v1/inbox/conversations/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getInboxConversationsListQueryOptions = <TData = Awaited<ReturnType<typeof inboxConversationsList>>, TError = unknown>(params?: InboxConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInboxConversationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof inboxConversationsList>>> = ({ signal }) => inboxConversationsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InboxConversationsListQueryResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsList>>>
export type InboxConversationsListQueryError = unknown


export function useInboxConversationsList<TData = Awaited<ReturnType<typeof inboxConversationsList>>, TError = unknown>(
 params: undefined |  InboxConversationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsList>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsList<TData = Awaited<ReturnType<typeof inboxConversationsList>>, TError = unknown>(
 params?: InboxConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsList>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsList<TData = Awaited<ReturnType<typeof inboxConversationsList>>, TError = unknown>(
 params?: InboxConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInboxConversationsList<TData = Awaited<ReturnType<typeof inboxConversationsList>>, TError = unknown>(
 params?: InboxConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInboxConversationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type inboxConversationsRetrieveResponse200 = {
  data: Conversation
  status: 200
}
    
export type inboxConversationsRetrieveResponseSuccess = (inboxConversationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsRetrieveResponse = (inboxConversationsRetrieveResponseSuccess)

export const getInboxConversationsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/`
}

export const inboxConversationsRetrieve = async (id: string, options?: RequestInit): Promise<inboxConversationsRetrieveResponse> => {
  
  return apiFetch<inboxConversationsRetrieveResponse>(getInboxConversationsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getInboxConversationsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/inbox/conversations/${id}/`
    ] as const;
    }

    
export const getInboxConversationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInboxConversationsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof inboxConversationsRetrieve>>> = ({ signal }) => inboxConversationsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InboxConversationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsRetrieve>>>
export type InboxConversationsRetrieveQueryError = unknown


export function useInboxConversationsRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInboxConversationsRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInboxConversationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type inboxConversationsUpdateResponse200 = {
  data: Conversation
  status: 200
}
    
export type inboxConversationsUpdateResponseSuccess = (inboxConversationsUpdateResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsUpdateResponse = (inboxConversationsUpdateResponseSuccess)

export const getInboxConversationsUpdateUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/`
}

export const inboxConversationsUpdate = async (id: string,
    conversationRequest: ConversationRequest, options?: RequestInit): Promise<inboxConversationsUpdateResponse> => {
  
  return apiFetch<inboxConversationsUpdateResponse>(getInboxConversationsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      conversationRequest,)
  }
);}




export const getInboxConversationsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsUpdate>>, TError,{id: string;data: ConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsUpdate>>, TError,{id: string;data: ConversationRequest}, TContext> => {

const mutationKey = ['inboxConversationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsUpdate>>, {id: string;data: ConversationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  inboxConversationsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsUpdate>>>
    export type InboxConversationsUpdateMutationBody = ConversationRequest
    export type InboxConversationsUpdateMutationError = unknown

    export const useInboxConversationsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsUpdate>>, TError,{id: string;data: ConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsUpdate>>,
        TError,
        {id: string;data: ConversationRequest},
        TContext
      > => {

      const mutationOptions = getInboxConversationsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type inboxConversationsPartialUpdateResponse200 = {
  data: Conversation
  status: 200
}
    
export type inboxConversationsPartialUpdateResponseSuccess = (inboxConversationsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsPartialUpdateResponse = (inboxConversationsPartialUpdateResponseSuccess)

export const getInboxConversationsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/`
}

export const inboxConversationsPartialUpdate = async (id: string,
    patchedConversationRequest: PatchedConversationRequest, options?: RequestInit): Promise<inboxConversationsPartialUpdateResponse> => {
  
  return apiFetch<inboxConversationsPartialUpdateResponse>(getInboxConversationsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedConversationRequest,)
  }
);}




export const getInboxConversationsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>, TError,{id: string;data: PatchedConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>, TError,{id: string;data: PatchedConversationRequest}, TContext> => {

const mutationKey = ['inboxConversationsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>, {id: string;data: PatchedConversationRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  inboxConversationsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>>
    export type InboxConversationsPartialUpdateMutationBody = PatchedConversationRequest
    export type InboxConversationsPartialUpdateMutationError = unknown

    export const useInboxConversationsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>, TError,{id: string;data: PatchedConversationRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsPartialUpdate>>,
        TError,
        {id: string;data: PatchedConversationRequest},
        TContext
      > => {

      const mutationOptions = getInboxConversationsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type inboxConversationsMessagesListResponse200 = {
  data: PaginatedMessageList
  status: 200
}
    
export type inboxConversationsMessagesListResponseSuccess = (inboxConversationsMessagesListResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsMessagesListResponse = (inboxConversationsMessagesListResponseSuccess)

export const getInboxConversationsMessagesListUrl = (id: string,
    params?: InboxConversationsMessagesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/inbox/conversations/${id}/messages/?${stringifiedParams}` : `/api/v1/inbox/conversations/${id}/messages/`
}

export const inboxConversationsMessagesList = async (id: string,
    params?: InboxConversationsMessagesListParams, options?: RequestInit): Promise<inboxConversationsMessagesListResponse> => {
  
  return apiFetch<inboxConversationsMessagesListResponse>(getInboxConversationsMessagesListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getInboxConversationsMessagesListQueryKey = (id?: string,
    params?: InboxConversationsMessagesListParams,) => {
    return [
    `/api/v1/inbox/conversations/${id}/messages/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getInboxConversationsMessagesListQueryOptions = <TData = Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError = unknown>(id: string,
    params?: InboxConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInboxConversationsMessagesListQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof inboxConversationsMessagesList>>> = ({ signal }) => inboxConversationsMessagesList(id,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InboxConversationsMessagesListQueryResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsMessagesList>>>
export type InboxConversationsMessagesListQueryError = unknown


export function useInboxConversationsMessagesList<TData = Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError = unknown>(
 id: string,
    params: undefined |  InboxConversationsMessagesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsMessagesList>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsMessagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsMessagesList<TData = Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError = unknown>(
 id: string,
    params?: InboxConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsMessagesList>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsMessagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsMessagesList<TData = Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError = unknown>(
 id: string,
    params?: InboxConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInboxConversationsMessagesList<TData = Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError = unknown>(
 id: string,
    params?: InboxConversationsMessagesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsMessagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInboxConversationsMessagesListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type inboxConversationsReadCreateResponse200 = {
  data: Conversation
  status: 200
}
    
export type inboxConversationsReadCreateResponseSuccess = (inboxConversationsReadCreateResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsReadCreateResponse = (inboxConversationsReadCreateResponseSuccess)

export const getInboxConversationsReadCreateUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/read/`
}

export const inboxConversationsReadCreate = async (id: string, options?: RequestInit): Promise<inboxConversationsReadCreateResponse> => {
  
  return apiFetch<inboxConversationsReadCreateResponse>(getInboxConversationsReadCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getInboxConversationsReadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsReadCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsReadCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['inboxConversationsReadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsReadCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  inboxConversationsReadCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsReadCreate>>>
    
    export type InboxConversationsReadCreateMutationError = unknown

    export const useInboxConversationsReadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsReadCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsReadCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getInboxConversationsReadCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A human answers (the conversation switches to human mode).
 */
export type inboxConversationsSendCreateResponse201 = {
  data: Message
  status: 201
}
    
export type inboxConversationsSendCreateResponseSuccess = (inboxConversationsSendCreateResponse201) & {
  headers: Headers;
};
;

export type inboxConversationsSendCreateResponse = (inboxConversationsSendCreateResponseSuccess)

export const getInboxConversationsSendCreateUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/send/`
}

export const inboxConversationsSendCreate = async (id: string,
    sendRequest: SendRequest, options?: RequestInit): Promise<inboxConversationsSendCreateResponse> => {
  
  return apiFetch<inboxConversationsSendCreateResponse>(getInboxConversationsSendCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendRequest,)
  }
);}




export const getInboxConversationsSendCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSendCreate>>, TError,{id: string;data: SendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSendCreate>>, TError,{id: string;data: SendRequest}, TContext> => {

const mutationKey = ['inboxConversationsSendCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsSendCreate>>, {id: string;data: SendRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  inboxConversationsSendCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsSendCreate>>>
    export type InboxConversationsSendCreateMutationBody = SendRequest
    export type InboxConversationsSendCreateMutationError = unknown

    export const useInboxConversationsSendCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSendCreate>>, TError,{id: string;data: SendRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsSendCreate>>,
        TError,
        {id: string;data: SendRequest},
        TContext
      > => {

      const mutationOptions = getInboxConversationsSendCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * N16: a voice reply recorded in the Pro app (human mode, like a typed answer).
 */
export type inboxConversationsVoiceCreateResponse201 = {
  data: Message
  status: 201
}
    
export type inboxConversationsVoiceCreateResponseSuccess = (inboxConversationsVoiceCreateResponse201) & {
  headers: Headers;
};
;

export type inboxConversationsVoiceCreateResponse = (inboxConversationsVoiceCreateResponseSuccess)

export const getInboxConversationsVoiceCreateUrl = (id: string,) => {


  

  return `/api/v1/inbox/conversations/${id}/voice/`
}

export const inboxConversationsVoiceCreate = async (id: string,
    voiceRequest: VoiceRequest, options?: RequestInit): Promise<inboxConversationsVoiceCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, voiceRequest.file)

  return apiFetch<inboxConversationsVoiceCreateResponse>(getInboxConversationsVoiceCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getInboxConversationsVoiceCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>, TError,{id: string;data: VoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>, TError,{id: string;data: VoiceRequest}, TContext> => {

const mutationKey = ['inboxConversationsVoiceCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>, {id: string;data: VoiceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  inboxConversationsVoiceCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsVoiceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>>
    export type InboxConversationsVoiceCreateMutationBody = VoiceRequest
    export type InboxConversationsVoiceCreateMutationError = unknown

    export const useInboxConversationsVoiceCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>, TError,{id: string;data: VoiceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsVoiceCreate>>,
        TError,
        {id: string;data: VoiceRequest},
        TContext
      > => {

      const mutationOptions = getInboxConversationsVoiceCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test mode only: pretend a client wrote on WhatsApp (demo and tests without Meta).
 */
export type inboxConversationsSimulateCreateResponse201 = {
  data: Message
  status: 201
}
    
export type inboxConversationsSimulateCreateResponseSuccess = (inboxConversationsSimulateCreateResponse201) & {
  headers: Headers;
};
;

export type inboxConversationsSimulateCreateResponse = (inboxConversationsSimulateCreateResponseSuccess)

export const getInboxConversationsSimulateCreateUrl = () => {


  

  return `/api/v1/inbox/conversations/simulate/`
}

export const inboxConversationsSimulateCreate = async (simulateRequest: SimulateRequest, options?: RequestInit): Promise<inboxConversationsSimulateCreateResponse> => {
  
  return apiFetch<inboxConversationsSimulateCreateResponse>(getInboxConversationsSimulateCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      simulateRequest,)
  }
);}




export const getInboxConversationsSimulateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>, TError,{data: SimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>, TError,{data: SimulateRequest}, TContext> => {

const mutationKey = ['inboxConversationsSimulateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>, {data: SimulateRequest}> = (props) => {
          const {data} = props ?? {};

          return  inboxConversationsSimulateCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InboxConversationsSimulateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>>
    export type InboxConversationsSimulateCreateMutationBody = SimulateRequest
    export type InboxConversationsSimulateCreateMutationError = unknown

    export const useInboxConversationsSimulateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>, TError,{data: SimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inboxConversationsSimulateCreate>>,
        TError,
        {data: SimulateRequest},
        TContext
      > => {

      const mutationOptions = getInboxConversationsSimulateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-115: unread figures over every visible conversation (the list is paginated).
 */
export type inboxConversationsSummaryRetrieveResponse200 = {
  data: InboxSummary
  status: 200
}
    
export type inboxConversationsSummaryRetrieveResponseSuccess = (inboxConversationsSummaryRetrieveResponse200) & {
  headers: Headers;
};
;

export type inboxConversationsSummaryRetrieveResponse = (inboxConversationsSummaryRetrieveResponseSuccess)

export const getInboxConversationsSummaryRetrieveUrl = () => {


  

  return `/api/v1/inbox/conversations/summary/`
}

export const inboxConversationsSummaryRetrieve = async ( options?: RequestInit): Promise<inboxConversationsSummaryRetrieveResponse> => {
  
  return apiFetch<inboxConversationsSummaryRetrieveResponse>(getInboxConversationsSummaryRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getInboxConversationsSummaryRetrieveQueryKey = () => {
    return [
    `/api/v1/inbox/conversations/summary/`
    ] as const;
    }

    
export const getInboxConversationsSummaryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInboxConversationsSummaryRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>> = ({ signal }) => inboxConversationsSummaryRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InboxConversationsSummaryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>>
export type InboxConversationsSummaryRetrieveQueryError = unknown


export function useInboxConversationsSummaryRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsSummaryRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInboxConversationsSummaryRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInboxConversationsSummaryRetrieve<TData = Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inboxConversationsSummaryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInboxConversationsSummaryRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




